function postForm(url, params, method = 'POST') {
  const form = document.createElement('form');
  form.setAttribute('method', method);
  form.setAttribute('action', url);
  for (const [key, value] of Object.entries(params)) {
    const hiddenField = document.createElement('input');
    hiddenField.setAttribute('type', 'hidden');
    hiddenField.setAttribute('name', key);
    hiddenField.setAttribute('value', value);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
}
export default postForm;